import React from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import Checkbox from 'material-ui/Checkbox';
import Dotdotdot from 'react-dotdotdot';
import { withStyles } from 'material-ui/styles';
import Card, { CardContent, CardMedia } from 'material-ui/Card';
import Typography from 'material-ui/Typography';
import CardOverlay from './CardOverlay';
import ProjectImageElement from '../../../ProjectImageElement';
// import { objToArr } from '../../../../../helpers';

const styles = theme => ({
  media: {
    height: 200,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
    color: theme.palette.text.secondary,
  },
  pos: {
    marginBottom: 12,
    color: theme.palette.text.secondary,
  },
});

const cardStyle = {
  position: 'relative',
  cursor: 'pointer',
  padding: '10px',
  height: '380px',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: 'none',
  backgroundColor: '#eee',
  borderRadius: '0px',
};

const checkbox = {
  style: {
    color: '#17E685',
    height: '100%',
    marginLeft: 'auto',
    justifyContent: 'flex-end',
  },
  icon: {
    color: '#084D2C',
  },
};

class ProjectGridElement extends React.Component {
  getProjectImage() {
    const { favicon: { downloadURL = null } = {} } = this.props || {};
    return downloadURL;
  }

  render() {
    // let isSelected = this.props.selected ? selected: this.props.style;
    const { batchEdit, selected, onClick, classes, name, description, date, size } = this.props;

    const image = this.getProjectImage();

    return (
      <div style={{ flex: '0 0 25%', padding: '0px 5px 10px 5px', overflow: 'hidden' }}>
        <Card className={classes.card} style={cardStyle} onClick={() => onClick()}>
          <ProjectImageElement
            alt=""
            imageUrl={image}
            containerStyle={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flex: '1',
              position: 'relative',
              height: '200px',
              width: '100%',
              background: 'rgb(204, 204, 204)',
              flexDirection: 'row',
              overflow: 'hidden',
            }}
          />

          <CardContent
            style={{
              padding: '0px',
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                paddingTop: '5px',
                paddingBottom: '5px',
              }}
            >
              <Typography className={classes.title} title={name}>
                <Dotdotdot clamp={2}>{name}</Dotdotdot>
              </Typography>
              {batchEdit && (
                <Checkbox
                  checked={selected}
                  style={checkbox.style}
                  iconStyle={{ fill: 'red' }}
                  onCheck={() => this.onCheck()}
                />
              )}
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
                flex: 1,
              }}
            >
              <Typography
                className={classes.description}
                title={description}
                style={{ paddingTop: '5px', paddingBottom: '5px' }}
              >
                <Dotdotdot clamp={3}>{description}</Dotdotdot>
              </Typography>
              <Typography
                className={classes.date}
                style={{ paddingTop: '5px', paddingBottom: '5px' }}
              >
                <Dotdotdot clamp={2}>{date}</Dotdotdot>
              </Typography>
              <Typography
                className={classes.size}
                style={{ paddingTop: '5px', paddingBottom: '5px' }}
              >
                <Dotdotdot clamp={1}>{size}</Dotdotdot>
              </Typography>
            </div>
          </CardContent>
          {selected && <CardOverlay />}
        </Card>
      </div>
    );
  }
}

ProjectGridElement.defaultProps = {
  name: '',
  description: '',
  date: '',
  size: '',
};
ProjectGridElement.propTypes = {
  batchEdit: PropTypes.bool.isRequired,
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  classes: PropTypes.objectOf(String).isRequired,
  name: PropTypes.string,
  description: PropTypes.string,
  date: PropTypes.string,
  size: PropTypes.string,
  scenes: PropTypes.shape().isRequired,
};

export default withStyles(styles)(Radium(ProjectGridElement));



// WEBPACK FOOTER //
// ./src/components/Project/ProjectList/ProjectListGrid/ProjectGridElement/ProjectGridElement.js